module.exports = __webpack_public_path__ + "static/media/77.c2d0da4b.jpg";